<script setup>
import { onMounted, reactive, ref, watch } from "vue";
import { apiQuery } from "@/api/j24api";
import DashboardPieChart from "@/views/dashboard/DashboardPieChart.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import VSelectSearch from "@/components/VSelectSearch.vue";
import ElevateReportBreakdown from "@/views/elevate/ElevateReportBreakdown.vue";
import convertToCsv from "./ConvertToCSV.js";
import ElevateESFEvent from "./ElevateESFEvent.vue";
import { permissionsStore } from "@/stores/permissions";
import ElevateLicence from "./ElevateLicence.vue";
const permissions = permissionsStore();
import PieChart from "@/components/PieChart.vue";
import ElevateReportBreakdownESF from "./ElevateReportBreakdownESF.vue";
import { appBarStore } from "@/stores/appBar";
const appBar = appBarStore();

//const report = ref("");

var licenceName = ref("");
const licences = reactive([]);
const useV2Api = ref(false);

const dateFrom = new Date();
dateFrom.setDate(dateFrom.getDate() - 1);
const loading = ref(false);
const eventsTab = ref("activityByUser");
const activateESF = ref(false);
const esfApps = ref({});
const esfBreakdownData = reactive([]);
const esfBreakdownTitle = ref("");

permissions.$subscribe((mutation, state) => {
  if (state["Elevate-SecurityLogs"]) {
    activateESF.value = true;
  } else {
    activateESF.value = false;
  }
});

appBar.$subscribe((mutation, state) => {
  if (appBar.selected != "") {
    licenceName.value = appBar.selected;
    getData();
  }
});

const tiles = reactive({
  numberOfElevations: {
    query: "where length(lengthofelevation) > 0 | count",
    result: {},
    status: "",
    loading: true,
  },
  reasonBreakdown: {
    query: "where length(lengthofelevation) > 0 | count by reason",
    result: {},
    status: "",
    loading: true,
  },
  requestTimeBreakdown: {
    query: "where length(lengthofelevation) > 0 | count by lengthOfElevation",
    result: {},
    status: "",
    loading: true,
  },
  activityByUser: {
    query:
      "where length(lengthofelevation) > 0| sort by licenseName, user | 1 as i|accum i as Elevations by user | sort by licenseName, user, Elevations | dedup consecutive by licenseName, user|reason as LastElevationReason | dateTimeRequested as LastDateTimeElevated | serialNumber as LastSerialNumber | lengthOfElevation as LastLengthOfElevation | count(user) group by user, Elevations, LastElevationReason, LastDateTimeElevated, LastSerialNumber, LastLengthOfElevation | sort by Elevations | fields - _count",
    result: {},
    status: "",
    loading: true,
  },
  actByDevice: {
    query:
      "where length(lengthofelevation) > 0| sort by licenseName, serialnumber | 1 as i|accum i as Elevations by serialnumber | sort by licenseName, serialnumber, Elevations | dedup consecutive by licenseName, serialnumber|reason as LastElevationReason | dateTimeRequested as LastDateTimeElevated | user as LastUserName | lengthOfElevation as LastLengthOfElevation | count(serialnumber) group by serialnumber, Elevations, LastElevationReason, LastDateTimeElevated, LastUserName, LastLengthOfElevation | sort by Elevations | fields - _count",
    result: {},
    status: "",
    loading: true,
  },
  // last100Elevations: {
  //   query: "where length(lengthofelevation) > 0 | sort _messageTime| limit 100",
  //   result: {},
  //   status: "",
  //   loading: true,
  // },
});

const headersActivity = [
  { text: "Username", value: "map.user", sortable: true },
  { text: "Elevations", value: "map.elevations", sortable: true },
  {
    text: "Last Elevation Reason",
    value: "map.lastelevationreason",
    sortable: true,
  },
  {
    text: "Last Time Elevated",
    value: "map.lastdatetimeelevated",
    sortable: true,
  },
  { text: "Last Serial Number", value: "map.lastserialnumber", sortable: true },
  {
    text: "Last Length Of Elevation",
    value: "map.lastlengthofelevation",
    sortable: true,
  },
];

const headersActivityByDevice = [
  { text: "Device Serial Number", value: "map.serialnumber", sortable: true },
  { text: "Elevations", value: "map.elevations", sortable: true },
  {
    text: "Last Elevation Reason",
    value: "map.lastelevationreason",
    sortable: true,
  },
  {
    text: "Last Time Elevated",
    value: "map.lastdatetimeelevated",
    sortable: true,
  },
  { text: "Last Username", value: "map.lastusername", sortable: true },
  {
    text: "Last Length Of Elevation",
    value: "map.lastlengthofelevation",
    sortable: true,
  },
];

// var headersLast100 = reactive([
//   { text: "Username", value: "map.user", sortable: true },
//   { text: "Serial Number", value: "map.serialnumber", sortable: true },
//   {
//     text: "Date Time Requested",
//     value: "map.datetimerequested",
//     sortable: true,
//   },
//   { text: "Reason", value: "map.reason", sortable: true },
//   { text: "Reason User Text", value: "map.reasonusertext", sortable: true },
//   // {
//   //   text: "Actions",
//   //   value: "actions",
//   //   sortable: false,
//   // },
// ]);

const selectedEsfSession = ref("");
const selectedEsfSessionUsername = ref("");
const selectedEsfSessionSerialNumber = ref("");

function selectEsf(item) {
  console.log(item);
  if (item.map?.sessionid) {
    selectedEsfSessionUsername.value = item.map.user;
    selectedEsfSessionSerialNumber.value = item.map.serialnumber;
    selectedEsfSession.value = item.map.sessionid;
    mainTab.value = "esf";
  }
}

function closeEsf() {
  selectedEsfSession.value = "";
  selectedEsfSessionUsername.value = "";
  selectedEsfSessionSerialNumber.value = "";
  mainTab.value = "main";
}

function preparePieChart(sumoData, keyName) {
  var pieData = { labels: [], datasets: [{ data: [] }] };
  sumoData.forEach((message) => {
    pieData.labels.push(message.map[keyName]);
    pieData.datasets[0].data.push(message.map._count);
  });
  return addChartColors(pieData);
}

const wholePageLoading = ref(true);

function toCsvByUser(data) {
  var csv = [];
  data.forEach((row) => {
    csv.push({
      Username: row.map.user,
      Elevations: row.map.elevations,
      "Last Elevation Reason": row.map.lastelevationreason,
      "Last Time Elevated": row.map.lastdatetimeelevated,
      "Last Serial Number": row.map.lastserialnumber,
      "Last Length Of Elevation": row.map.lastlengthofelevation,
    });
  });
  return csv;
}

function convertToCsvByDevice(data) {
  var csv = [];
  data.forEach((row) => {
    csv.push({
      "Device Serial Number": row.map.serialnumber,
      Elevations: row.map.elevations,
      "Last Elevation Reason": row.map.lastelevationreason,
      "Last Time Elevated": row.map.lastdatetimeelevated,
      "Last Username": row.map.lastusername,
      "Last Length Of Elevation": row.map.lastlengthofelevation,
    });
  });
  return csv;
}

async function getLicences() {
  wholePageLoading.value = true;
  const result = await apiQuery("ELA", "elevatereports", {
    apiAction: "GetLicences",
  });
  if (result.length) {
    licences.length = 0;
    licences.push(...result);
  }
  if (licences.length == 1) {
    licenceName.value = licences[0].name;
    getData();
  }
  wholePageLoading.value = false;
}

// function convertElevationsToInt() {
//   const keys = Object.keys(tiles);
//   console.log("Keys", keys);
//   // Loop through each tile result and where elevations is a string convert to int
//   for (const key in keys) {
//     let tile = keys[key];
//     if (tiles[tile].result?.messages?.length) {
//       for (let i = 0; i < tiles[tile].result.messages.length; i++) {
//         if (tiles[tile].result.messages[i].map.elevations) {
//           tiles[tile].result.messages[i].map.elevations = parseInt(
//             tiles[tile].result.messages[i].map.elevations
//           );
//         }
//       }
//     }
//   }
// }

const esfLoading = ref(false);

//  MARK: getESF
async function getESF(useV2Api = false) {
  esfLoading.value = true;
  esfAppsPieChart.value = { labels: [], values: [], data: [] };
  esfBlockedPieChart.value = { labels: [], values: [], data: [] };
  esfConfProfilePieChart.value = { labels: [], values: [], data: [] };
  esfLaunchItemsPieChart.value = { labels: [], values: [], data: [] };
  esfUsersPieChart.value = { labels: [], values: [], data: [] };
  const result = await apiQuery("ELA", "elevatereports", {
    apiAction: "ESFReport",
    esfReportAction: "GetDashboard",
    elevateLicence: licenceName.value,
    dateFrom: selectedTimePeriod.value.from.toISOString(),
    dateTo: selectedTimePeriod.value.to.toISOString(),
  });

  console.log("ESF Dash result", result);
  if (result.appChanges.length) {
    // Collate the app change data
    const appsChanged = [];
    const appsAdded = [];
    const appsRemoved = [];

    result.appChanges.forEach((record) => {
      console.log(record);
      switch (record.eventtype) {
        case "Application:Add":
          appsAdded.push(record);
          break;
        case "Application:Changed":
          appsChanged.push(record);
          break;
        case "Application:Removed":
          appsRemoved.push(record);
          break;
      }
    });
    console.log("Apps Added", appsAdded);
    esfApps.value = {
      appsChanged: appsChanged,
      appsAdded: appsAdded,
      appsRemoved: appsRemoved,
    };

    var pieData = { labels: [], values: [], data: [] };
    pieData.labels.push("Added");
    pieData.values.push(appsAdded.length);
    pieData.data.push(appsAdded);
    pieData.labels.push("Changed");
    pieData.values.push(appsChanged.length);
    pieData.data.push(appsChanged);
    pieData.labels.push("Removed");
    pieData.values.push(appsRemoved.length);
    pieData.data.push(appsRemoved);
    esfAppsPieChart.value = pieData;
  }

  if (result.blockedActions?.length) {
    pieData = { labels: [], values: [], data: [] };
    // Loop through the blocked actions adding them by the value of eventtype
    result.blockedActions.forEach((record) => {
      var index = pieData.labels.indexOf(record.eventtype);
      if (index == -1) {
        pieData.labels.push(record.eventtype);
        pieData.values.push(1);
        pieData.data.push([record]);
      } else {
        pieData.values[index]++;
        pieData.data[index].push(record);
      }
    });
    esfBlockedPieChart.value = pieData;
  }

  if (result.confProfiles?.length) {
    pieData = { labels: [], values: [], data: [] };
    // Loop through the conf profiles looking for event types Profile:Remove and Profile:Add set lables to Removed and Added
    result.confProfiles.forEach((record) => {
      if (record.eventtype == "Profile:Remove") {
        if (pieData.labels.indexOf("Removed") == -1) {
          pieData.labels.push("Removed");
          pieData.values.push(1);
          pieData.data.push([record]);
        } else {
          pieData.values[pieData.labels.indexOf("Removed")]++;
          pieData.data[pieData.labels.indexOf("Removed")].push(record);
        }
      }
      if (record.eventtype == "Profile:Add") {
        if (pieData.labels.indexOf("Added") == -1) {
          pieData.labels.push("Added");
          pieData.values.push(1);
          pieData.data.push([record]);
        } else {
          pieData.values[pieData.labels.indexOf("Added")]++;
          pieData.data[pieData.labels.indexOf("Added")].push(record);
        }
      }
    });
    esfConfProfilePieChart.value = pieData;
  }

  if (result.launchItems?.length) {
    pieData = { labels: [], values: [], data: [] };
    result.launchItems.forEach((record) => {
      if (record.eventtype == "LaunchItem:Remove") {
        if (pieData.labels.indexOf("Removed") == -1) {
          pieData.labels.push("Removed");
          pieData.values.push(1);
          pieData.data.push([record]);
        } else {
          pieData.values[pieData.labels.indexOf("Removed")]++;
          pieData.data[pieData.labels.indexOf("Removed")].push(record);
        }
      }
      if (record.eventtype == "LaunchItem:Add") {
        if (pieData.labels.indexOf("Added") == -1) {
          pieData.labels.push("Added");
          pieData.values.push(1);
          pieData.data.push([record]);
        } else {
          pieData.values[pieData.labels.indexOf("Added")]++;
          pieData.data[pieData.labels.indexOf("Added")].push(record);
        }
      }
    });
    esfLaunchItemsPieChart.value = pieData;
  }

  if (result.users?.length) {
    pieData = { labels: [], values: [], data: [] };
    result.users.forEach((record) => {
      if (record.eventtype == "User:Delete") {
        if (pieData.labels.indexOf("Deleted") == -1) {
          pieData.labels.push("Deleted");
          pieData.values.push(1);
          pieData.data.push([record]);
        } else {
          pieData.values[pieData.labels.indexOf("Deleted")]++;
          pieData.data[pieData.labels.indexOf("Deleted")].push(record);
        }
      }
      if (record.eventtype == "User:Create") {
        if (pieData.labels.indexOf("Created") == -1) {
          pieData.labels.push("Created");
          pieData.values.push(1);
          pieData.data.push([record]);
        } else {
          pieData.values[pieData.labels.indexOf("Created")]++;
          pieData.data[pieData.labels.indexOf("Created")].push(record);
        }
      }
    });
    esfUsersPieChart.value = pieData;
  }

  // If using new API
  if (useV2Api) {
    const keys = Object.keys(tiles);
    for (const key in keys) {
      console.log("Key", key);
      console.log(keys[key]);
      switch (keys[key]) {
        case "numberOfElevations":
          tiles[keys[key]].result = {
            messages: [
              {
                map: {
                  _count: result.usageData,
                },
              },
            ],
          };
          tiles[keys[key]].status = "Complete";
          tiles[keys[key]].loading = false;
          break;
        case "reasonBreakdown":
          if (result.reasonBreakdown) {
            tiles[keys[key]].labels = [];
            tiles[keys[key]].values = [];
            result.reasonBreakdown.forEach((item) => {
              tiles[keys[key]].labels.push(item._id);
              tiles[keys[key]].values.push(item.count);
            });
            tiles[keys[key]].status = "Complete";
            tiles[keys[key]].loading = false;
          }
          break;
        case "requestTimeBreakdown":
          if (result.lengthBreakdown) {
            tiles[keys[key]].labels = [];
            tiles[keys[key]].values = [];
            result.lengthBreakdown.forEach((item) => {
              tiles[keys[key]].labels.push(item._id);
              tiles[keys[key]].values.push(item.count);
            });
            tiles[keys[key]].status = "Complete";
            tiles[keys[key]].loading = false;
            tiles[keys[key]].labels.forEach((label, index) => {
              if (label == "0") {
                tiles[keys[key]].labels[index] = "0 Minutes";
              } else {
                console.log("Label", label);
                tiles[keys[key]].labels[index] =
                  formatSecondsToMinutesHours(label);
              }
            });
          }
          break;
        case "activityByUser":
          if (result.userActivity?.length) {
            tiles[keys[key]].result = {
              messages: result.userActivity,
            };
            tiles[keys[key]].status = "Complete";
            tiles[keys[key]].loading = false;
          }
          break;
        case "actByDevice":
          if (result.deviceActivity?.length) {
            tiles[keys[key]].result = {
              messages: result.deviceActivity,
            };
            tiles[keys[key]].status = "Complete";
            tiles[keys[key]].loading = false;
          }
          break;
      }
    }
  }

  loading.value = false;
  esfLoading.value = false;
}

const esfAppsPieChart = ref({ labels: [], values: [], data: [] });
const esfBlockedPieChart = ref({ labels: [], values: [], data: [] });
const esfConfProfilePieChart = ref({ labels: [], values: [], data: [] });
const esfLaunchItemsPieChart = ref({ labels: [], values: [], data: [] });
const esfUsersPieChart = ref({ labels: [], values: [], data: [] });

const esfAppsHeaders = {
  headers: [
    { text: "Username", value: "sessionStart.username", sortable: true },
    {
      text: "Serial Number",
      value: "sessionStart.serialNumber",
      sortable: true,
    },
    {
      text: "Date Time Requested",
      value: "sessionStartTimestamp",
      sortable: true,
    },
    { text: "Application Path", value: "path", sortable: true },
    { text: "App Bundle ID", value: "CFBundleIdentifier", sortable: true },
    { text: "", value: "actions", sortable: false },
  ],
};

const esfBlockedHeaders = {
  headers: [
    { text: "Username", value: "sessionStart.username", sortable: true },
    {
      text: "Serial Number",
      value: "sessionStart.serialNumber",
      sortable: true,
    },
    {
      text: "Date Time Requested",
      value: "sessionStartTimestamp",
      sortable: true,
    },
    { text: "App ID Requesting", value: "signingid", sortable: true },
    { text: "Action Blocked", value: "eventtype", sortable: true },
    { text: "Target", value: "target", sortable: true },
    { text: "", value: "actions", sortable: false },
  ],
};

const esfConfigHeaders = {
  headers: [
    { text: "Username", value: "sessionStart.username", sortable: true },
    {
      text: "Serial Number",
      value: "sessionStart.serialNumber",
      sortable: true,
    },
    {
      text: "Date Time Requested",
      value: "sessionStartTimestamp",
      sortable: true,
    },
    { text: "Action", value: "eventtype", sortable: true },
    { text: "App ID Requesting", value: "signingid", sortable: true },
    { text: "Target", value: "target", sortable: true },
    { text: "", value: "actions", sortable: false },
  ],
};

const esfBreakdownHeaders = ref([]);

function clickHandlerReason(data, config) {
  console.log("Click Handler Reason", data, config);
  const index = config.dataPointIndex;
  const query =
    'where length(lengthofelevation) > 0 | where reason matches "' +
    config.w.config.labels[index] +
    '"';
  selectedCustomQuery.value = query;
  mainTab.value = "breakdown";
}

function clickHandlerLength(data, config) {
  const index = config.dataPointIndex;
  const query =
    'where length(lengthofelevation) > 0 |where lengthofelevation matches "' +
    config.w.config.labels[index] +
    '"';
  selectedCustomQuery.value = query;
  mainTab.value = "breakdown";
}

function clickHandlerAll() {
  const query = "where length(lengthofelevation) > 0";
  selectedCustomQuery.value = query;
  mainTab.value = "breakdown";
}

function esfClickHandler(data, config) {
  console.log("esfClickHandler", data, config);
  if (data) {
    if (data[0].eventtype) {
      esfBreakdownTitle.value = data[0].eventtype;
    }
    esfBreakdownData.length = 0;
    esfBreakdownData.push(...data);
    if (config.w?.config?.j24AdditionalData?.headers) {
      esfBreakdownHeaders.value = config.w.config.j24AdditionalData.headers;
    }
    mainTab.value = "breakdownEsf";
  }
}

function esfViewAll(data, headers, title) {
  esfBreakdownTitle.value = title;
  esfBreakdownData.length = 0;
  for (const key in data) {
    esfBreakdownData.push(...data[key]);
  }
  if (headers) {
    const actionsHeader = headers.headers.find((h) => h.value === "actions");
    esfBreakdownHeaders.value = [
      ...headers.headers.filter((h) => h.value !== "actions"),
      { text: "Action", value: "eventtype", sortable: true },
      ...(actionsHeader ? [actionsHeader] : []),
    ];
  }
  mainTab.value = "breakdownEsf";
}

async function getData() {
  if (licenceName.value) {
    //return;
  }
  loading.value = true;
  var timePeriod;
  if (selectedTimePeriod.value.title == "Custom Range") {
    timePeriod = {
      from: chosenRange.value[0],
      to: chosenRange.value[1],
    };
  } else {
    console.log("Using selected time period", selectedTimePeriod.value);
    switch (selectedTimePeriod.value.title) {
      case "Last 24 Hours":
        timePeriod = {
          from: daysAgo(1),
          to: new Date(),
        };
        break;
      case "Last 3 Days":
        timePeriod = {
          from: daysAgo(3),
          to: new Date(),
        };
        break;
      case "Last 7 Days":
        timePeriod = {
          from: daysAgo(7),
          to: new Date(),
        };
        break;
      case "Last 14 Days":
        timePeriod = {
          from: daysAgo(14),
          to: new Date(),
        };
        break;
      case "Last 30 Days":
        timePeriod = {
          from: daysAgo(30),
          to: new Date(),
        };
        break;

      default:
        timePeriod = selectedTimePeriod.value;
    }
    selectedTimePeriod.value.from = timePeriod.from;
    selectedTimePeriod.value.to = timePeriod.to;
  }

  let switchOverDate = new Date("2025-09-01T05:35:48.000+00:00");

  const keys = Object.keys(tiles);
  for (const key in keys) {
    tiles[keys[key]].loading = true;
  }
  tiles.numberOfElevations.result.messages = [];

  console.log(selectedTimePeriod.value);
  // Check selectedTimerPeriod from and to if both are before switchOverDate then use old API
  if (
    selectedTimePeriod.value.from < switchOverDate ||
    selectedTimePeriod.value.to < switchOverDate
  ) {
    console.log("Using old API");
    useV2Api.value = false;
    getESF(false);
  } else {
    useV2Api.value = true;
    console.log("Using new API");
    getESF(true);
    return;
  }

  console.log("Keys", keys);
  for (const key in keys) {
    const result = await apiQuery("ELA", "elevatereports", {
      apiAction: "CreateRequest",
      licenceName: licenceName.value,
      from: timePeriod.from.toISOString().split(".")[0],
      to: timePeriod.to.toISOString().split(".")[0],
      //query: tiles[keys[key]].query,
      query: tiles[keys[key]].query,
    });
    if (result.reportId) {
      tiles[keys[key]].reportId = result.reportId;
      tiles[keys[key]].loading = true;
      tiles[keys[key]].status = "Waiting for report";
    }
    console.log(result);
  }

  var allDataRecieved = false;
  var maxRequests = 100;
  var count = 0;
  while (!allDataRecieved && count < maxRequests) {
    count++;

    var finished = true;
    for (const key in keys) {
      await sleep(1000);
      if (tiles[keys[key]].status == "Waiting for report") {
        const result = await apiQuery("ELA", "elevatereports", {
          apiAction: "GetStatus",
          reportID: tiles[keys[key]].reportId,
        });
        console.log(result);
        if (result?.state == "DONE GATHERING RESULTS") {
          const messages = await apiQuery("ELA", "elevatereports", {
            apiAction: "GetMessages",
            reportID: tiles[keys[key]].reportId,
          });
          console.log(keys[key]);
          console.log("Messages Received", messages);
          tiles[keys[key]].result = messages;
          tiles[keys[key]].loading = false;
          tiles[keys[key]].status = "Complete";
          var labelKey;
          switch (keys[key]) {
            case "numberOfElevations":
              break;
            case "reasonBreakdown":
              labelKey = "reason";
              break;
            case "requestTimeBreakdown":
              labelKey = "lengthofelevation";
              break;
          }
          if (labelKey) {
            tiles[keys[key]].labels = [];
            tiles[keys[key]].values = [];

            messages.messages.forEach((message) => {
              //console.log(message.map);
              tiles[keys[key]].labels.push(message.map[labelKey]);
              // need to convert to int

              tiles[keys[key]].values.push(+message.map._count);
            });

            if (labelKey == "lengthofelevation") {
              tiles[keys[key]].labels.forEach((label, index) => {
                if (label == "0") {
                  tiles[keys[key]].labels[index] = "0 Minutes";
                } else {
                  // If Label is an Int convert to minutes
                  if (Number.isInteger(+label)) {
                    tiles[keys[key]].labels[index] = label / 60 + " Minutes";
                  } else {
                    console.log("Not an Int", label);
                  }
                }
              });
            }
          }
          tiles[keys[key]].loading = false;
        } else {
          finished = false;
        }
        //return;
      }
    }
    if (finished) {
      console.log("All data recieved");
      allDataRecieved = true;
    }
  }
  loading.value = false;
  // const fromDate = new Date();
  // fromDate.setDate(fromDate.getDate() - 1);
  // const now = new Date();
  // const result = await apiQuery("ELA", "elevatereports", {
  //   apiAction: "CreateRequest",
  //   licenceName: "Jigsaw24 Elevate Demo",
  //   from: fromDate.toISOString().split(".")[0],
  //   to: now.toISOString().split(".")[0],
  //   query: '"lengthOfElevation"',
  // });
  // console.log(result);
  // report.value = result;
}

// async function getStatus() {
//   const result = await apiQuery("ELA", "elevatereports", {
//     apiAction: "GetStatus",
//     reportID: report.value.reportId,
//   });
//   console.log(result);
// }

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

onMounted(() => {
  //getData();
  if (permissions.$state) {
    if (permissions.$state["Elevate-SecurityLogs"]) {
      activateESF.value = true;
      // headersLast100.push({
      //   text: "Actions",
      //   value: "actions",
      //   sortable: false,
      // });
    }
  }
  getLicences();
  if (appBar.selected != "") {
    licenceName.value = appBar.selected;
    getData();
  }
  // headersLast100.push({
  //   text: "Actions",
  //   value: "actions",
  //   sortable: false,
  // });
});

const pieChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "right",
    },
  },
};

function addChartColors(chartData) {
  const colors = [
    "#EB5D0B",
    "#7B264B",
    "#2D728F",
    "#1D7874",
    "#FFE0B5",
    "#E49AB0",
    "#B3DEC1",
    "#1B998B",
    "#82D173",
    "#FFA9E7",
  ];
  var counter = 0;
  var colourCounter = 0;
  const coloursRequired = chartData.datasets[0].data.length;
  while (counter < coloursRequired) {
    counter++;
    if (!chartData.datasets[0].backgroundColor) {
      chartData.datasets[0].backgroundColor = [colors[colourCounter]];
    } else {
      chartData.datasets[0].backgroundColor.push(colors[colourCounter]);
    }
    if (colourCounter == colors.length) {
      colourCounter = 0;
    }
    colourCounter++;
  }
  return chartData;
}

function daysAgo(days) {
  var x = new Date();
  x.setDate(x.getDate() - days);
  return x;
}

const presetTimePeriods = [
  { title: "Last 24 Hours", from: daysAgo(1), to: new Date() },
  { title: "Last 3 Days", from: daysAgo(3), to: new Date() },
  { title: "Last 7 Days", from: daysAgo(7), to: new Date() },
  { title: "Last 14 Days", from: daysAgo(14), to: new Date() },
  { title: "Last 30 Days", from: daysAgo(30), to: new Date() },
];

const selectedTimePeriod = ref({
  title: "Last 24 Hours",
  from: daysAgo(1),
  to: new Date(),
});

function searchFields(headers) {
  var result = [];
  headers.forEach((header) => {
    result.push(header.value);
  });
  return result;
}

const last100Search = ref("");
const activityByUserSearch = ref("");

const chosenRange = ref();
const startTime = [
  { hours: 0, minutes: 0 },
  { hours: 0, minutes: 0 },
];

const loadingCustomReport = ref(false);
const customReport = ref(false);
const customReportMessages = reactive([]);
const customReportCardHeight = ref(420);

function cleanUpMessages(messages) {
  const newArray = [];
  messages.forEach((message) => {
    const newObject = {};
    const keys = Object.keys(message.map);
    console.log(keys);
    keys.forEach((key) => {
      if (
        key[0] != "_" &&
        key != "sessionid" &&
        key != "licensename" &&
        key != "customer"
      ) {
        newObject[key] = message.map[key];
      }
    });
    newArray.push(newObject);
  });
  return newArray;
}

async function getCustomReport() {
  loadingCustomReport.value = true;
  try {
    const result = await apiQuery("ELA", "elevatereports", {
      apiAction: "CreateRequest",
      licenceName: licenceName.value,
      from: chosenRange.value[0].toISOString().split(".")[0],
      to: chosenRange.value[1].toISOString().split(".")[0],
      query: "where length(lengthofelevation) > 0",
    });
    var count = 0;
    const reportId = result.reportId;
    while (count < 100) {
      count++;
      await sleep(1000);
      const result = await apiQuery("ELA", "elevatereports", {
        apiAction: "GetStatus",
        reportID: reportId,
      });
      if (result?.state == "DONE GATHERING RESULTS") {
        const data = await apiQuery("ELA", "elevatereports", {
          apiAction: "GetMessages",
          reportID: reportId,
        });

        customReportMessages.push(...cleanUpMessages(data.messages));
        count = 999999;
      }
    }
    if (customReportMessages.length > 0) {
      customReportCardHeight.value = undefined;
    }
  } catch (error) {
    console.log(error);
  }
  loadingCustomReport.value = false;
}

const customReportHeaders = [
  { text: "Username", value: "user" },
  { text: "Serial Number", value: "serialnumber" },
  { text: "Date Time Requested", value: "datetimerequested" },
  { text: "Reason", value: "reason" },
  { text: "Reason User Text", value: "reasonusertext" },
];

const mainTab = ref("main");
const selectedSerialNumber = ref("");
const selectedUser = ref("");
const selectedCustomQuery = ref("");

const selectDevice = (event) => {
  console.log(event.map);
  console.log(event.map.serialnumber);
  selectedSerialNumber.value = event.map.serialnumber;
  selectedCustomQuery.value = "";
  selectedUser.value = "";
  mainTab.value = "breakdown";
  return;
};

const selectUser = (event) => {
  console.log(event.map);
  console.log(event.map.user);
  selectedUser.value = event.map.user;
  selectedSerialNumber.value = "";
  mainTab.value = "breakdown";

  return;
  // selectedSerialNumber.value = "";
  // selectedUser.value = event.map.user;
  // mainTab.value = "breakdown";
  // console.log(event);
};

const showCustomTimePeriodSelector = ref(false);

// watch(selectedTimePeriod, (newValue, oldValue) => {
//   if (newValue.title == "Custom Range") {
//     showCustomTimePeriodSelector.value = true;
//   } else {
//     showCustomTimePeriodSelector.value = false;
//   }
// });

watch(chosenRange, (newValue, oldValue) => {
  console.log(newValue);
  selectedTimePeriod.value = {
    title: formatDate(newValue[0]) + " to " + formatDate(newValue[1]),
    from: newValue[0],
    to: newValue[1],
  };
});

function formatDate(date) {
  const pad = (num) => (num < 10 ? "0" + num : num);

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // Months are zero-based
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

function formatSecondsToMinutesHours(seconds) {
  if (isNaN(seconds) || seconds === null) return seconds.toLowerCase();
  const s = parseInt(seconds, 10);
  if (s < 60) return `${s} seconds`;
  const minutes = Math.floor(s / 60);
  if (minutes < 60) return `${minutes} minutes`;
  const hours = Math.floor(minutes / 60);
  const remMinutes = minutes % 60;
  if (remMinutes === 0) return `${hours} hours`;
  return `${hours} hours ${remMinutes} minutes`;
}
</script>

<template>
  <v-dialog v-model="showCustomTimePeriodSelector" max-width="700">
    <v-card>
      <v-card-title>Choose Reporting Period</v-card-title>
      <v-card-text>
        <VueDatePicker
          inline
          range
          auto-apply
          v-model="chosenRange"
          placeholder="Select Date Range"
          :startTime="startTime"
        />
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Page is loading -->
  <template v-if="wholePageLoading">
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-center pt-11">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </template>
  <template v-else>
    <v-window v-model="mainTab" class="pa-0 ma-0">
      <v-window-item value="main" class="pa-1 ma-0">
        <!-- CUSTOM REPORT -->
        <v-row v-if="customReport">
          <v-col cols="12">
            <v-card :height="customReportCardHeight">
              <v-card-title
                ><v-row>
                  <v-col>Custom Report</v-col>
                  <v-spacer></v-spacer>
                  <v-icon
                    class="ma-2"
                    @click="customReport = false"
                    icon="mdi-close"
                  ></v-icon> </v-row
              ></v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="4">
                    <VueDatePicker
                      range
                      auto-apply
                      v-model="chosenRange"
                      placeholder="Select Date Range"
                      :startTime="startTime"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      :loading="loadingCustomReport"
                      @click="getCustomReport()"
                      >Get Report</v-btn
                    >
                  </v-col>
                  <v-col
                    v-if="customReportMessages.length > 0"
                    class="text-right"
                  >
                    <download-csv
                      :data="customReportMessages"
                      name="Elevate24 Report.csv"
                    >
                      <v-btn prepend-icon="mdi-download">Download</v-btn>
                    </download-csv>
                  </v-col>
                </v-row>
                <v-row> </v-row>
                <template v-if="customReportMessages.length > 0">
                  <v-row>
                    <v-col cols="12">
                      <EasyDataTable
                        :headers="customReportHeaders"
                        :items="customReportMessages"
                        theme-color="#e7541e"
                      />
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- First Page -->
        <v-row>
          <v-col cols="auto" v-if="licences.length" class="mt-2">
            <!-- <VSelectSearch
              v-if="licences.length > 1"
              label="Choose Elevate License"
              :items="licences"
              itemTitle="name"
              itemValue="name"
              v-model="licenceName"
              variant="underlined"
              hideDetails
              density="compact"
              @update:modelValue="getData()"
              activateSearch
            >
            </VSelectSearch> -->
            <template v-if="!licenceName">
              <h2>Select Elevate Licence to create report</h2>
            </template>
          </v-col>

          <v-spacer />
          <v-col cols="auto" class="px-0">
            <v-btn rounded="0" variant="text" icon="mdi-calendar-month"
              ><v-icon>mdi-calendar-month</v-icon>
              <v-menu activator="parent">
                <VueDatePicker
                  inline
                  range
                  auto-apply
                  v-model="chosenRange"
                  placeholder="Select Date Range"
                  :startTime="startTime"
                />
              </v-menu>
            </v-btn>
          </v-col>
          <v-col cols="3" class="text-right mt-2 px-0"
            ><v-select
              label="Report Time Period"
              :items="presetTimePeriods"
              return-object
              item-title="title"
              v-model="selectedTimePeriod"
              variant="underlined"
              hide-details
              density="compact"
            >
            </v-select>
          </v-col>
          <v-col cols="auto" class="text-right pl-0">
            <v-btn
              @click="getData()"
              :disabled="loading"
              rounded="0"
              icon="mdi-magnify"
              variant="text"
            ></v-btn
          ></v-col>
        </v-row>

        <template v-if="licenceName">
          <v-row>
            <v-col cols="4">
              <v-card :loading="tiles.numberOfElevations.loading" :height="250">
                <v-card-title>
                  <v-row>
                    <v-col> Number of Elevations </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto"
                      ><v-icon
                        :disabled="
                          !tiles.numberOfElevations.result.messages ||
                          !tiles.numberOfElevations.result.messages.length
                        "
                        @click="clickHandlerAll()"
                        >mdi-list-box-outline</v-icon
                      >
                      <v-tooltip activator="parent">{{
                        tiles.numberOfElevations.result.messages &&
                        tiles.numberOfElevations.result.messages.length
                          ? "View All"
                          : "No Data"
                      }}</v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text class="pointer" @click="clickHandlerAll()">
                  <div
                    v-if="
                      tiles.numberOfElevations.result.messages &&
                      tiles.numberOfElevations.result.messages.length
                    "
                    class="text-center text-h1 pt-10"
                  >
                    <template
                      v-if="
                        tiles.numberOfElevations.result.messages.length == 0
                      "
                    >
                      0
                    </template>
                    <template v-else>
                      {{
                        tiles.numberOfElevations.result.messages[0].map._count
                      }}
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card :loading="tiles.reasonBreakdown.loading" :height="250">
                <v-card-title>
                  <v-row>
                    <v-col> Reason Breakdown </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto"
                      ><v-icon
                        :disabled="
                          !tiles.reasonBreakdown.labels ||
                          !tiles.reasonBreakdown.labels.length
                        "
                        @click="clickHandlerAll()"
                        >mdi-list-box-outline</v-icon
                      >
                      <v-tooltip activator="parent">{{
                        tiles.reasonBreakdown.labels &&
                        tiles.reasonBreakdown.labels.length
                          ? "View All"
                          : "No Data"
                      }}</v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <PieChart
                    v-if="
                      !tiles.reasonBreakdown.loading &&
                      tiles.reasonBreakdown.labels &&
                      tiles.reasonBreakdown.labels.length != 0
                    "
                    :labels="tiles.reasonBreakdown.labels"
                    :values="tiles.reasonBreakdown.values"
                    @clickDataPoint="clickHandlerReason"
                  />
                  <template v-else>
                    <v-row v-if="!tiles.reasonBreakdown.loading">
                      <v-spacer></v-spacer>
                      <v-col class="text-center">
                        <h1 class="pt-10">No Data</h1>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card
                :loading="tiles.requestTimeBreakdown.loading"
                :height="250"
              >
                <v-card-title>
                  <v-row>
                    <v-col> Elevation Length Breakdown </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto"
                      ><v-icon
                        :disabled="
                          !tiles.requestTimeBreakdown.labels ||
                          !tiles.requestTimeBreakdown.labels.length
                        "
                        @click="clickHandlerAll()"
                        >mdi-list-box-outline</v-icon
                      >
                      <v-tooltip activator="parent">{{
                        tiles.requestTimeBreakdown.labels &&
                        tiles.requestTimeBreakdown.labels.length
                          ? "View All"
                          : "No Data"
                      }}</v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text class="justify-center">
                  <PieChart
                    v-if="
                      !tiles.requestTimeBreakdown.loading &&
                      tiles.requestTimeBreakdown.labels &&
                      tiles.requestTimeBreakdown.labels.length != 0
                    "
                    :labels="tiles.requestTimeBreakdown.labels"
                    :values="tiles.requestTimeBreakdown.values"
                    @clickDataPoint="clickHandlerLength"
                  />
                  <template v-else>
                    <v-row v-if="!tiles.requestTimeBreakdown.loading">
                      <v-spacer></v-spacer>
                      <v-col class="text-center">
                        <h1 class="pt-10">No Data</h1>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="activateESF">
            <v-col cols="4">
              <v-card :height="250" :loading="esfLoading">
                <v-card-title>
                  <v-row>
                    <v-col> Application Changes </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto"
                      ><v-icon
                        :disabled="
                          !esfAppsPieChart.labels ||
                          !esfAppsPieChart.labels.length
                        "
                        @click="
                          esfViewAll(
                            esfAppsPieChart.data,
                            esfAppsHeaders,
                            'Application Changes'
                          )
                        "
                        >mdi-list-box-outline</v-icon
                      >
                      <v-tooltip activator="parent">{{
                        esfAppsPieChart.labels && esfAppsPieChart.labels.length
                          ? "View All"
                          : "No Data"
                      }}</v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <PieChart
                    v-if="
                      esfAppsPieChart.labels && esfAppsPieChart.labels.length
                    "
                    :labels="esfAppsPieChart.labels"
                    :values="esfAppsPieChart.values"
                    :data="esfAppsPieChart.data"
                    :additionalData="esfAppsHeaders"
                    @clickDataPoint="esfClickHandler"
                  />
                  <template v-else>
                    <v-row v-if="!esfLoading">
                      <v-spacer></v-spacer>
                      <v-col class="text-center">
                        <h1 class="pt-10">No Data</h1>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card :height="250" :loading="esfLoading">
                <v-card-title>
                  <v-row>
                    <v-col> Blocked Actions </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto"
                      ><v-icon
                        :disabled="
                          !esfBlockedPieChart.labels ||
                          !esfBlockedPieChart.labels.length
                        "
                        @click="
                          esfViewAll(
                            esfBlockedPieChart.data,
                            esfBlockedHeaders,
                            'Blocked Actions'
                          )
                        "
                        >mdi-list-box-outline</v-icon
                      >
                      <v-tooltip activator="parent">{{
                        esfBlockedPieChart.labels &&
                        esfBlockedPieChart.labels.length
                          ? "View All"
                          : "No Data"
                      }}</v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <PieChart
                    v-if="
                      esfBlockedPieChart.labels &&
                      esfBlockedPieChart.labels.length
                    "
                    :labels="esfBlockedPieChart.labels"
                    :values="esfBlockedPieChart.values"
                    :data="esfBlockedPieChart.data"
                    :additionalData="esfBlockedHeaders"
                    @clickDataPoint="esfClickHandler"
                  />
                  <template v-else>
                    <v-row v-if="!esfLoading">
                      <v-spacer></v-spacer>
                      <v-col class="text-center">
                        <h1 class="pt-10">No Data</h1>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card :height="250" :loading="esfLoading">
                <v-card-title>
                  <v-row>
                    <v-col> Configuration Profile Changes </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto"
                      ><v-icon
                        :disabled="
                          !esfConfProfilePieChart.labels ||
                          !esfConfProfilePieChart.labels.length
                        "
                        @click="
                          esfViewAll(
                            esfConfProfilePieChart.data,
                            esfConfigHeaders,
                            'Configuration Profile Changes'
                          )
                        "
                        >mdi-list-box-outline</v-icon
                      >
                      <v-tooltip activator="parent">{{
                        esfConfProfilePieChart.labels &&
                        esfConfProfilePieChart.labels.length
                          ? "View All"
                          : "No Data"
                      }}</v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <PieChart
                    v-if="
                      esfConfProfilePieChart.labels &&
                      esfConfProfilePieChart.labels.length
                    "
                    :labels="esfConfProfilePieChart.labels"
                    :values="esfConfProfilePieChart.values"
                    :data="esfConfProfilePieChart.data"
                    :additionalData="esfConfigHeaders"
                    @clickDataPoint="esfClickHandler"
                  />
                  <template v-else>
                    <v-row v-if="!esfLoading">
                      <v-spacer></v-spacer>
                      <v-col class="text-center">
                        <h1 class="pt-10">No Data</h1>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card :height="250" :loading="esfLoading">
                <v-card-title>
                  <v-row>
                    <v-col> User Account Changes </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto"
                      ><v-icon
                        :disabled="
                          !esfUsersPieChart.labels ||
                          !esfUsersPieChart.labels.length
                        "
                        @click="
                          esfViewAll(
                            esfUsersPieChart.data,
                            esfConfigHeaders,
                            'User Account Changes'
                          )
                        "
                        >mdi-list-box-outline</v-icon
                      >
                      <v-tooltip activator="parent">{{
                        esfUsersPieChart.labels &&
                        esfUsersPieChart.labels.length
                          ? "View All"
                          : "No Data"
                      }}</v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <PieChart
                    v-if="
                      esfUsersPieChart.labels && esfUsersPieChart.labels.length
                    "
                    :labels="esfUsersPieChart.labels"
                    :values="esfUsersPieChart.values"
                    :data="esfUsersPieChart.data"
                    :additionalData="esfConfigHeaders"
                    @clickDataPoint="esfClickHandler"
                  />
                  <template v-else>
                    <v-row v-if="!esfLoading">
                      <v-spacer></v-spacer>
                      <v-col class="text-center">
                        <h1 class="pt-10">No Data</h1>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card :height="250" :loading="esfLoading">
                <v-card-title>
                  <v-row>
                    <v-col> Launch Item Changes </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto"
                      ><v-icon
                        :disabled="
                          !esfLaunchItemsPieChart.labels ||
                          !esfLaunchItemsPieChart.labels.length
                        "
                        @click="
                          esfViewAll(
                            esfLaunchItemsPieChart.data,
                            esfConfigHeaders,
                            'Launch Item Changes'
                          )
                        "
                        >mdi-list-box-outline</v-icon
                      >
                      <v-tooltip activator="parent">{{
                        esfLaunchItemsPieChart.labels &&
                        esfLaunchItemsPieChart.labels.length
                          ? "View All"
                          : "No Data"
                      }}</v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <PieChart
                    v-if="
                      esfLaunchItemsPieChart.labels &&
                      esfLaunchItemsPieChart.labels.length
                    "
                    :labels="esfLaunchItemsPieChart.labels"
                    :values="esfLaunchItemsPieChart.values"
                    :data="esfLaunchItemsPieChart.data"
                    :additionalData="esfConfigHeaders"
                    @clickDataPoint="esfClickHandler"
                  />
                  <template v-else>
                    <v-row v-if="!esfLoading">
                      <v-spacer></v-spacer>
                      <v-col class="text-center">
                        <h1 class="pt-10">No Data</h1>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-tabs v-model="eventsTab" color="#e7541e">
                <!-- <v-tab value="last100">Last 100 elevations</v-tab> -->
                <v-tab value="activityByUser">Activity By User</v-tab>
                <v-tab value="activityByDevice">Activity By Device</v-tab>
              </v-tabs>
            </v-col>

            <v-col cols="12">
              <v-window v-model="eventsTab">
                <v-window-item value="activityByUser">
                  <v-card>
                    <v-card-title>
                      <v-row>
                        <!-- <v-col>Activity By User</v-col> -->
                        <v-col>
                          <v-text-field
                            density="compact"
                            variant="underlined"
                            hide-details
                            label="Search Text"
                            v-model="activityByUserSearch"
                          >
                          </v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="text-right">
                          <download-csv
                            v-if="!tiles.activityByUser.loading"
                            :data="
                              toCsvByUser(tiles.activityByUser.result.messages)
                            "
                            name="ActivityByUser.csv"
                          >
                            <v-btn aria-label="Download"
                              ><v-icon>mdi-download</v-icon></v-btn
                            >
                          </download-csv>
                        </v-col>
                      </v-row>
                    </v-card-title>

                    <EasyDataTable
                      class="mx-2 mb-2"
                      v-if="tiles.activityByUser.loading"
                      :loading="tiles.activityByUser.loading"
                      :items="[]"
                      :headers="headersActivity"
                      theme-color="#e7541e"
                    />
                    <EasyDataTable
                      v-else
                      class="mx-2 mb-2"
                      :loading="tiles.activityByUser.loading"
                      :headers="headersActivity"
                      :items="tiles.activityByUser.result.messages"
                      theme-color="#e7541e"
                      :search-field="searchFields(headersActivity)"
                      :search-value="activityByUserSearch"
                      sort-by="map.elevations"
                      sort-type="desc"
                      must-sort
                      alternating
                      @click-row="selectUser"
                    />
                  </v-card>
                </v-window-item>
                <v-window-item value="activityByDevice">
                  <v-card>
                    <v-card-title>
                      <v-row>
                        <v-col>
                          <v-text-field
                            density="compact"
                            variant="underlined"
                            hide-details
                            label="Search..."
                            v-model="activityByDeviceSearch"
                          ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="text-right">
                          <download-csv
                            v-if="!tiles.actByDevice.loading"
                            :data="
                              toCsvByDevice(tiles.actByDevice.result.messages)
                            "
                            name="ActivityByDevice.csv"
                          >
                            <v-btn aria-label="Download"
                              ><v-icon>mdi-download</v-icon></v-btn
                            >
                          </download-csv>
                        </v-col>
                      </v-row>
                    </v-card-title>

                    <EasyDataTable
                      class="mx-2 mb-2"
                      v-if="tiles.actByDevice.loading"
                      :loading="tiles.actByDevice.loading"
                      :items="[]"
                      :headers="headersActivity"
                      theme-color="#e7541e"
                    />
                    <EasyDataTable
                      v-else
                      class="mx-2 mb-2"
                      :loading="tiles.actByDevice.loading"
                      :headers="headersActivityByDevice"
                      :items="tiles.actByDevice.result.messages"
                      theme-color="#e7541e"
                      :search-field="searchFields(headersActivity)"
                      :search-value="activityByDeviceSearch"
                      sort-by="map.elevations"
                      sort-type="desc"
                      must-sort
                      alternating
                      @click-row="selectDevice"
                    />
                  </v-card>
                </v-window-item>
              </v-window>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12"> </v-col>
          </v-row>
        </template>
      </v-window-item>

      <v-window-item value="breakdown" class="pa-1">
        <!-- <v-row>
          <v-col cols="auto">
            <v-btn prepend-icon="mdi-arrow-left" @click="mainTab = 'main'"
              >Back</v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
        </v-row> -->
        <v-row>
          <v-col cols="12">
            <ElevateReportBreakdown
              v-if="mainTab == 'breakdown'"
              :licenceName="licenceName"
              :from="selectedTimePeriod.from"
              :to="selectedTimePeriod.to"
              :serialNumber="selectedSerialNumber"
              :username="selectedUser"
              :activateESF="activateESF"
              :customQuery="selectedCustomQuery"
              :useV2Api="useV2Api"
              @back="mainTab = 'main'"
            />
          </v-col>
        </v-row>
      </v-window-item>

      <v-window-item value="breakdownEsf">
        <ElevateReportBreakdownESF
          v-if="esfBreakdownData.length"
          :data="esfBreakdownData"
          :title="esfBreakdownTitle"
          :licenceName="licenceName"
          :headers="esfBreakdownHeaders"
          @back="
            mainTab = 'main';
            esfBreakdownData.length = 0;
          "
        />
      </v-window-item>

      <v-window-item value="esf" class="pa-1">
        <ElevateESFEvent
          v-if="mainTab == 'esf'"
          :licenceName="licenceName"
          :serialNumber="selectedEsfSessionSerialNumber"
          :username="selectedEsfSessionUsername"
          :eventReference="selectedEsfSession"
          @back="closeEsf()"
        />
      </v-window-item>
    </v-window>
  </template>
</template>
